// extracted by mini-css-extract-plugin
export default {"otpInput":"OtpInput_otpInput__nl77o","previousPage":"OtpInput_previousPage__Ap1e-","previousPageLink":"OtpInput_previousPageLink__Dh8Q1"};